import script from "./ProductPreviewComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductPreviewComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ProductPreviewComponent.vue?vue&type=style&index=0&id=8a967ca0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a967ca0"]])

export default __exports__